/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './DocumentsPanel.scss';
import BaseReactComponent from '../Util/BaseReactComponent';
import baseComponent from '../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import DocumentList from './List/DocumentsList';


@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class DocumentsPanel extends BaseReactComponent {

    removeDocument(document) {
        this.props.removeDocument(document);
    }

    render() {
        let subTitle = this.getMessage('title');

        return (
            <div className="DocumentsPanel">
                <div className="DocumentsPanel-header">
                    <div className="container">
                        <div className="col-sm-9">
                            <h1>{subTitle}</h1>
                        </div>
                        <div className="col-sm-3">
                            <button className="btn btn-primary add-new-button" onClick={this.props.addDocument.bind(this)}>{this.getMessage('add-new-button')}</button>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <DocumentList removeDocument={this.removeDocument.bind(this)}/>
                </div>
            </div>
        );
    }

}

DocumentsPanel.propTypes = {
    addDocument: React.PropTypes.func,
    removeDocument: React.PropTypes.func
};

DocumentsPanel.defaultProps = {
    componentName: 'documents-panel'
};

export default DocumentsPanel;




// WEBPACK FOOTER //
// /src/components/Document/DocumentsPanel.js